import { MapTypeEnum } from "./mapTypeEnum";

export const EndCodeMapTypeEnum = Object.freeze({
    [MapTypeEnum.roadmap]: 'r',
    [MapTypeEnum.raster]: 't',
    [MapTypeEnum.satellite]: 's',
    [MapTypeEnum.map3d]: 'd'
})